import TextareaAutogrow from 'stimulus-textarea-autogrow'

export default TextareaAutogrow
